/* Stroomkaart - translations: admin portal
   ============================================ */

/* eslint-disable @typescript-eslint/no-explicit-any */
export const nl = {
  /* ============================================================
     Admin portal (Beheerportaal)
     ============================================================ */
  admin: {
    bar: {
      portal:         'Beheerportaal',
      menu_label:     'Beheermenu',
      back_to_public: 'Terug naar publieke site',
      logout:         'Uitloggen',
    },
    nav: {
      groups: {
        operations:   'Operaties',
        power_points: 'Stroompunten',
        management:   'Beheer',
      },
      items: {
        dashboard:            'Dashboard',
        requests:             'Aanvragen',
        admin_map:            'Admin-kaart',
        power_stations:       'Power stations',
        indirect_stations:    'Indirect stations',
        ac_chargers:          'AC laders',
        dc_chargers:          'DC laders',
        water_points:         'Waterpunten',
        point_usage:          'Gebruikshistorie',
        scan_projects:        'Energie-scan',
        organizations:        'Organisaties',
        applications:         'Aanmeldingen',
        contact_messages:     'Contactberichten',
        installation_parties: 'Installatiepartijen',
        email_templates:      'E-mail templates',
        guidelines:           'Richtlijnen',
        users:                'Gebruikers',
        settings:             'Instellingen',
        audit_logs:           'Audit logs',
      },
    },
    actions: {
      edit:    'Bewerken',
      delete:  'Verwijderen',
      cancel:  'Annuleren',
      save:    'Opslaan',
      loading: 'Laden…',
      empty:   'Geen resultaten.',
      pager_prev: '← Vorige',
      pager_next: 'Volgende →',
      col_actions: 'Acties',
    },
    confirm: {
      delete_user:            'Weet u zeker dat u {email} wilt verwijderen?',
      delete_power_station:   'Weet u zeker dat u power station "{label}" wilt verwijderen?',
      delete_indirect_station:'Weet u zeker dat u indirect station "{label}" wilt verwijderen?',
      delete_water_point:     'Weet u zeker dat u waterpunt "{label}" wilt verwijderen?',
      delete_charging_station:'Weet u zeker dat u laadpunt "{label}" wilt verwijderen? Bij de volgende import kan het opnieuw verschijnen.',
      modal_title_delete:     'Verwijderen bevestigen',
      modal_confirm_delete:   'Verwijderen',
    },
    dashboard: {
      title:           'Welkom',
      sub:             'Kies hieronder een module om mee verder te werken.',
      cards: {
        requests:             { title: 'Aanvragen',           sub: 'Beoordeel en keur binnenkomende aanvragen goed of af.' },
        power_stations:       { title: 'Power stations',      sub: 'Stroompunten op de kaart toevoegen, bewerken en bulk-importeren.' },
        installation_parties: { title: 'Installatiepartijen', sub: 'Partijen die per organisatie bevoegd zijn om stroomkasten te openen.' },
        email_templates:      { title: 'E-mail templates',    sub: 'Pas transactionele e-mails aan per organisatie en stroompunt-type.' },
        organizations:        { title: 'Organisaties',        sub: 'Beheer de organisaties die stroompunten bezitten.' },
        applications:         { title: 'Aanmeldingen',        sub: 'Beoordeel inkomende aanmeldingen van nieuwe organisaties.' },
        users:                { title: 'Gebruikers',          sub: 'Platform-admins en organisatie-accounts.' },
        settings:             { title: 'Instellingen',        sub: 'Tariefmarge, importer-schema en andere runtime-instellingen.' },
        audit_logs:           { title: 'Audit logs',          sub: 'Wie wijzigde wat, en wanneer.' },
      },
    },
    users: {
      title:        'Gebruikers',
      sub:          'Platform-admins, operators en organisatie-accounts. Een nieuwe gebruiker krijgt direct een welkomstmail met tijdelijk wachtwoord.',
      new_btn:      'Nieuwe gebruiker',
      search_ph:    'Zoek op e-mail of naam…',
      empty:        'Nog geen gebruikers.',
      col: {
        email:    'E-mail',
        name:     'Naam',
        role:     'Rol',
        blocked:  'Geblokkeerd',
      },
      yes: 'ja',
      no:  'nee',
    },
    user_form: {
      title_new:           'Nieuwe gebruiker',
      title_edit:          'Gebruiker bewerken',
      section_identity:    'Identiteit',
      section_access:      'Rechten & toegang',
      label_email:         'E-mail',
      label_name:          'Naam',
      label_role:          'Rol',
      label_owner:         'Organisatie',
      label_blocked:       'Geblokkeerd',
      owner_placeholder:   '- Kies een organisatie -',
      owner_hint:          'Organisatie-gebruikers zien alleen rijen van hun eigen organisatie.',
      role_platform_admin:    'Platform admin (NRG, volledige rechten)',
      role_organization:      'Organisatie (per organisatie)',
      submit_new:          'Gebruiker aanmaken',
      submit_edit:         'Opslaan',
      saved:               'Opgeslagen.',
      created_html:        'Gebruiker {email} aangemaakt - een welkomstmail met tijdelijk wachtwoord is verstuurd.',
      err_load:            'Gebruiker laden mislukt.',
      err_save:            'Opslaan mislukt.',
    },
    power_stations: {
      title:     'Power stations',
      sub:       'Beheer alle vaste stroompunten op de kaart. Bewerk locatie, capaciteit en connectoren of voeg een nieuw punt toe.',
      new_btn:   'Nieuw power station',
      search_ph: 'Zoek op ID, adres of organisatie…',
      empty:     'Nog geen power stations.',
      col: {
        row_id:     'ID',
        id:         'Power station ID',
        address:    'Adres',
        city:       'Stad',
        capacity:   'Capaciteit',
        connectors: 'Connectoren',
      },
    },
    power_station_form: {
      title_new:    'Nieuw power station',
      title_edit:   'Power station bewerken',
      submit_new:   'Power station aanmaken',
      submit_edit:  'Wijzigingen opslaan',
      saved:        'Power station opgeslagen.',
      created:      'Power station aangemaakt.',
      err_load:     'Power station laden mislukt.',
      err_save:     'Opslaan mislukt.',
      images_placeholder_title: 'Afbeeldingen',
      images_placeholder_body:  'Sla het power station eerst op. Daarna kun je hier foto’s uploaden en de volgorde aanpassen.',
      images_confirm_delete:    'Deze foto verwijderen?',
      images_pick_label:        'Foto’s toevoegen (optioneel)',
      images_pick_hint:         'JPEG, PNG of WebP. Maximaal 5 MB per bestand. De eerste foto wordt als hoofdfoto getoond op de kaart.',
      uploading_progress:       'Foto {i} van {n} uploaden…',
      upload_partial:           'Power station aangemaakt, maar één of meer foto’s konden niet worden geüpload. Open de bewerkpagina om het opnieuw te proberen.',
    },
    indirect_stations: {
      title:     'Indirect stations',
      sub:       'Beheer indirecte stroompunten op de kaart. Bewerk locatie, capaciteit en connectoren of voeg een nieuw punt toe.',
      new_btn:   'Nieuw indirect station',
      search_ph: 'Zoek op ID, adres of organisatie…',
      empty:     'Nog geen indirect stations.',
      col: {
        id:         'Indirect station ID',
        address:    'Adres',
        city:       'Stad',
        capacity:   'Capaciteit',
        connectors: 'Connectoren',
      },
    },
    indirect_station_form: {
      title_new:  'Nieuw indirect station',
      title_edit: 'Indirect station bewerken',
      scouting_context: 'Energie-scan herkomst',
      scan_project_link: 'Toegevoegd vanuit project',
      google_place_id:   'Google place ID',
    },
    station_form: {
      connector_add_ph:  '+ Voeg ander type toe…',
      connector_add_btn: 'Toevoegen',
    },
    scouting_status: {
      unset:                 '- Geen scoutingstatus -',
      benaderd:              'Benaderd',
      positief:              'Positieve reactie',
      locatiebezoek_gepland: 'Locatiebezoek gepland',
      locatiebezoek_gehad:   'Locatiebezoek gehad',
      negatief:              'Afgewezen / negatief',
    },
    map: {
      title:               'Admin-kaart - Beheerportaal',
      sidebar_title:       'Admin-kaart',
      points_with_visibility: 'punten · privé overzicht - alle zichtbaarheden',
      search_placeholder:  'Zoek op naam, stad of adres…',
      filter_kind:         'Type aansluiting',
      filter_visibility:   'Zichtbaarheid',
      filter_source:       'Bron',
      visibility: {
        public:     'Publiek',
        admin_only: 'Alleen admin',
        draft:      'Concept',
      },
      source: {
        all:    'Alle',
        manual: 'Handmatig',
        csv:    'CSV',
        api:    'API',
        scout:  'Gescout',
      },
      banner:        'Privé overzicht - alleen zichtbaar voor ingelogde beheerders',
      aria_label:    'Admin-kaart van Nederland met alle stroompunten',
      detail_aria:   'Details stroompunt',
      detail: {
        btn_edit:           'Bewerken in beheer',
        from_scan_project:  'Toegevoegd vanuit Energie-scan',
      },
      vis_selector: {
        label: 'Zichtbaarheid',
        sub: {
          public:     'Iedereen ziet dit punt op de publieke kaart',
          admin_only: 'Verborgen op publieke kaart; intern wel zichtbaar',
          draft:      'Nog niet af; alleen voor mij zichtbaar',
        },
        confirm_demote: 'Punt verbergen voor de publieke kaart? Bestaande reserveringen blijven geldig - alleen de zichtbaarheid voor nieuwe bezoekers verandert.',
        err_change:     'Zichtbaarheid wijzigen mislukt.',
      },
      oda: {
        cta_title:      'Geen ODA-koppeling.',
        cta_body:       'Met een ODA-mandaat kunnen we de werkelijke kwartierwaarden via de netbeheerder uitlezen en tonen hoeveel kWh er overdag en \'s nachts vrij is.',
        cta_btn:        '+ ODA koppelen',
        linked_title:   'ODA-koppeling - overcapaciteit',
        prompt_title:   'ODA koppelen',
        prompt:         'Voer de 18-cijferige EAN-code van de aansluiting in.',
        link_btn:       'Koppelen',
        invalid:        'Ongeldige EAN-code - voer precies 18 cijfers in.',
        change_btn:     'EAN wijzigen',
        unlink_btn:     'Ontkoppelen',
        confirm_unlink: 'ODA-koppeling verwijderen?\n\nDe EAN-code verdwijnt van dit punt. Het mandaat blijft bij EDSN actief totdat je het daar ook intrekt.',
        err_change:     'EAN-code opslaan mislukt.',
        sync_btn:       'Vernieuwen',
        loading:        'Capaciteitsdata laden…',
        err_load:       'Capaciteitsdata laden mislukt. Probeer het later opnieuw.',
        no_data:        'Geen meetdata in dit venster.',
        no_limit:       'Geen zekeringtype bekend voor deze aansluiting - de vrije ruimte is daardoor niet te bepalen.',
        day:            'Dag',
        night:          'Nacht',
        figure_label:   'Gem. overcapaciteit',
        unit:           'kWh / dag',
        used:           'Gebruikt',
        free:           'Vrij',
        row_limit:      'Effectieve limiet',
        row_contracted: 'Contracteel beschikbaar',
        row_used:       'Gemiddeld verbruikt',
        row_window:     'Vensterduur',
        hours:          'uur',
        based_on:       'Gebaseerd op meetdata van',
        days:           'dagen',
      },
    },
    water_points: {
      title:     'Waterpunten',
      sub:       'Beheer drinkwaterpunten die naast stroompunten op de kaart verschijnen.',
      new_btn:   'Nieuw waterpunt',
      search_ph: 'Zoek op straat of type…',
      empty:     'Nog geen waterpunten.',
      col: {
        type:      'Type',
        street:    'Straat',
        number:    'Nummer',
        latitude:  'Latitude',
        longitude: 'Longitude',
      },
    },
    water_point_form: {
      title_new:    'Nieuw waterpunt',
      title_edit:   'Waterpunt bewerken',
      section_location: 'Locatie',
      section_status:   'Status',
      label_type:       'Type',
      label_street:     'Straatnaam',
      label_number:     'Huisnummer',
      label_latitude:   'Latitude',
      label_longitude:  'Longitude',
      label_status:     'Status',
      submit_new:       'Waterpunt aanmaken',
      submit_edit:      'Wijzigingen opslaan',
      saved:            'Waterpunt opgeslagen.',
      created:          'Waterpunt aangemaakt.',
      err_load:         'Waterpunt laden mislukt.',
      err_save:         'Opslaan mislukt.',
    },
    charging_stations: {
      title_ac:   'AC laders',
      title_dc:   'DC laders',
      sub:        'De dagelijkse import is leidend - handmatige wijzigingen zouden bij de volgende run overschreven worden, dus aanmaken/bewerken is hier niet beschikbaar. Status mag je per rij wel aanpassen (de import respecteert dat); verwijderen mag ook om verouderde rijen te schonen.',
      search_ph:  'Zoek op ID, naam, adres, stad of operator…',
      empty:      'Nog geen laadpunten.',
      col: {
        location_id: 'ID',
        name:        'Naam',
        operator:    'Operator',
        address:     'Adres',
        city:        'Stad',
        layers:      'Lagen',
        status:      'Status',
      },
    },
    point_status: {
      available:      'Beschikbaar',
      maintenance:    'Onderhoud',
      out_of_service: 'Buiten gebruik',
    },
    organization: {
      label:      'Organisatie',
      unassigned: '- Geen organisatie -',
    },
    point_usage: {
      title:         'Gebruikshistorie',
      sub:           'Hoe vaak en waarvoor stroompunten gebruikt worden. Alleen goedgekeurde boekingen tellen mee.',
      search_ph:     'Zoek op stroompunt, plaats, project of aanvrager…',
      empty:         'Geen gebruik gevonden in deze periode.',
      load_err:      'Kon de gebruikshistorie niet laden.',
      not_found:     'Dit stroompunt bestaat niet of valt niet onder uw organisatie.',
      back:          '← Alle stroompunten',
      pending:       '{n} in behandeling',
      manual:        'Handmatige blokkering',
      kind: {
        all:             'Alle typen',
        PowerStation:    'Power station',
        IndirectStation: 'Indirect station',
        ChargingStation: 'Laadpaal',
        WaterPoint:      'Waterpunt',
      },
      period: {
        m12:       'Laatste 12 maanden',
        m24:       'Laatste 24 maanden',
        this_year: 'Dit jaar',
        last_year: 'Vorig jaar',
      },
      sort: {
        days:   'Meest gebruikt',
        recent: 'Recent gebruikt',
        name:   'Naam',
      },
      col: {
        point:     'Stroompunt',
        bookings:  'Boekingen',
        days:      'Dagen',
        occupancy: 'Bezetting',
        last:      'Laatst gebruikt',
        next:      'Volgende boeking',
        projects:  'Projecten',
      },
      kpi: {
        days:      'Geboekte dagen',
        occupancy: 'Bezetting',
        bookings:  'Boekingen',
        next:      'Volgende boeking',
      },
      chart_title:   'Geboekte dagen per maand',
      history_title: 'Boekingshistorie',
      history_sub:   'Alle boekingen op dit stroompunt, nieuwste eerst. Niet beperkt tot de gekozen periode.',
      history_empty: 'Dit stroompunt is nog nooit geboekt.',
      hcol: {
        period:    'Periode',
        days:      'Dagen',
        project:   'Project',
        requester: 'Aanvrager',
        status:    'Status',
        request:   'Aanvraag',
      },
      status: {
        confirmed: 'Bevestigd',
        tentative: 'In behandeling',
        upcoming:  'Gepland',
      },
    },
    audit_logs: {
      title:     'Audit logs',
      sub:       'Append-only log van iedere admin-mutatie. Nieuwste eerst.',
      search_ph: 'Zoek op actor-e-mail of resource-id…',
      empty:     'Geen audit-events.',
      col: {
        timestamp: 'Tijdstempel (UTC)',
        actor:     'Actor',
        action:    'Actie',
        resource:  'Resource',
        details:   'Details',
      },
    },
    app_settings: {
      title:    'Instellingen',
      sub:      'Bestaande waarden inline bewerken. Nieuwe instellingen ontstaan door code-deploys; de standaardwaarden worden via een SQL-seed-script ingeladen.',
      empty:    'Nog geen instellingen.',
      col: {
        name:  'Naam',
        value: 'Waarde',
      },
    },
    organizations: {
      title:          'Organisaties',
      sub:            'Organisaties die stroompunten bezitten - gemeenten, havenautoriteiten, NRG. Organisatie-gebruikers worden aan één organisatie gekoppeld en zien alleen rijen die bij die organisatie horen.',
      new_btn:        'Organisatie toevoegen',
      title_new:      'Organisatie toevoegen',
      title_edit:     'Organisatie bewerken',
      lede:           'Een organisatie bezit stroompunten. Organisatie-gebruikers worden via hun rol aan precies één organisatie gekoppeld.',
      label_id:       'ID',
      hint_id:        'Korte sleutel - kleine letters, geen spaties. Niet meer wijzigbaar na aanmaak.',
      ph_id:          'bv. amsterdam',
      label_name:     'Naam',
      ph_name:        'bv. Gemeente Amsterdam',
      label_email:    'Contact e-mail (optioneel)',
      label_country:  'Land (ISO 2)',
      empty:          'Nog geen organisaties aangemaakt.',
      delete_confirm: 'Weet u zeker dat u "{label}" wilt verwijderen? Bestaande rijen die naar deze organisatie verwijzen worden ontkoppeld.',
      col: {
        id:      'ID',
        name:    'Naam',
        email:   'Contact e-mail',
        country: 'Land',
        created: 'Aangemaakt',
      },
      err_id:        'ID is verplicht.',
      err_name:      'Naam is verplicht.',
      err_country:   'Land is verplicht.',
      err_duplicate: 'Een organisatie met deze ID bestaat al.',
      err_save:      'Opslaan mislukt.',
      err_delete:    'Verwijderen mislukt.',
      err_load:      'Organisaties laden mislukt.',
    },
    guidelines: {
      title:           'Richtlijnen',
      sub:             'PDF-richtlijnen die aansluiters moeten ondertekenen voordat een aansluit-activiteit kan worden ingepland. Globale richtlijnen zijn voor alle organisaties beschikbaar.',
      new_btn:         'Richtlijn uploaden',
      include_archived:'Toon gearchiveerd',
      empty:           'Nog geen richtlijnen geüpload.',
      global:          'Globaal',
      version_label:   'v{version}',
      uploaded_by:     'Geüpload door {by} · {at}',
      archived_label:  'Gearchiveerd',
      modal_new_title: 'Richtlijn uploaden',
      modal_replace_title: 'Nieuwe versie uploaden',
      modal_replace_lede:  'De huidige versie wordt gearchiveerd en vervangen door deze nieuwe PDF. Historische ondertekensessies blijven naar de eerdere versie verwijzen.',
      label_name:      'Naam',
      ph_name:         'Bijv. Aansluitprotocol stroomkasten',
      label_language:  'Taal',
      ph_language:     'nl, en, …',
      label_owner:     'Organisatie',
      owner_global:    '- Globaal (alle organisaties) -',
      label_file:      'PDF-bestand',
      pdf_only_hint:   'Alleen application/pdf, max 20 MB.',
      action_download: 'Bekijk PDF',
      action_replace:  'Vervang',
      action_signers:  'Toon ondertekenaars',
      action_resend_signer: 'Stuur opnieuw',
      resend_confirm:    'Stuur deze richtlijn opnieuw naar {email} voor aanvraag {request}? Er wordt een nieuwe ondertekeningslink aangemaakt.',
      resend_sent:       'Verstuurd',
      err_resend_signer: 'Opnieuw versturen mislukt.',
      action_archive:  'Archiveer',
      action_unarchive:'Herstel',
      action_delete:   'Verwijder',
      col_signer:        'Ondertekenaar',
      col_email:         'E-mail',
      col_organisation:  'Organisatie',
      col_request:       'Aanvraag',
      col_accepted_at:   'Ondertekend op',
      signers_empty:     'Nog geen ondertekenaars voor deze versie.',
      delete_confirm:  'Definitief verwijderen van "{label}"? Dit kan niet worden teruggedraaid.',
      archive_confirm: '"{label}" archiveren? Aansluiters kunnen geen nieuwe sessies meer met deze versie starten.',
      err_load:        'Richtlijnen laden mislukt.',
      err_name:        'Naam is verplicht.',
      err_file:        'Selecteer een PDF-bestand.',
      err_save:        'Opslaan mislukt.',
      err_replace:     'Vervangen mislukt.',
      err_archive:     'Archiveren mislukt.',
      err_signers_load:'Ondertekenaars laden mislukt.',
      err_delete:      'Verwijderen mislukt.',
    },
    installation_parties: {
      title:        'Installatiepartijen',
      sub:          'Beheer welke partijen geïnformeerd worden om een stroomkast te openen, per gemeente. Deze partijen verschijnen als optie bij stap 4 van het aanvraagproces.',
      new_btn:      'Partij toevoegen',
      title_new:    'Partij toevoegen',
      title_edit:   'Partij bewerken',
      lede:         'Een installatiepartij ontvangt een mail wanneer een aansluit-activiteit op uw stroompunt wordt ingepland - eventueel met sleutel-instructies.',
      label_owner:  'Organisatie',
      label_name:   'Naam organisatie / team',
      label_email:  'E-mailadres',
      label_phone:  'Telefoon',
      label_notify_emails: 'Extra notificatie-adressen (optioneel)',
      label_notes:  'Notitie (intern, optioneel)',
      ph_name:      'Bijv. Stadsbeheer Eindhoven',
      ph_email:     'meldingen@partij.nl',
      ph_notify_emails: 'gemeente@amsterdam.nl, beheer@amsterdam.nl',
      help_notify_emails: 'Krijgen een kopie zodra deze partij een opdracht-mail ontvangt.',
      add_email:    'Toevoegen',
      err_email_invalid: 'Voer een geldig e-mailadres in.',
      cc_prefix:    'Cc:',
      ph_notes:     'Bijv. Sleutel ophalen op werkdagen tussen 8:00–16:00 bij stadhuis.',
      empty:        'Nog geen installatiepartijen toegevoegd.',
      delete_confirm: 'Weet u zeker dat u "{label}" wilt verwijderen?',
      err_name:     'Naam is verplicht.',
      err_owner:    'Selecteer een eigenaar.',
      err_save:     'Opslaan mislukt.',
      err_delete:   'Verwijderen mislukt.',
      err_load:     'Installatiepartijen laden mislukt.',
    },
    requests: {
      title:    'Alle aanvragen',
      sub:      'Overzicht van alle aanvragen die u kunt beheren.',
      empty:    'Geen aanvragen gevonden.',
      err_load: 'Aanvragen laden mislukt.',
      col: {
        id:       'Nummer',
        project:  'Project / organisatie',
        point:    'Stroompunten',
        period:   'Periode',
        status:   'Status',
        submitted:'Ingediend',
      },
      kpi: {
        total:   'Totaal',
        action:  'Wacht op actie',
        review:  'In behandeling',
        running: 'Lopend',
      },
      search_ph: 'Zoek op aanvraagnummer, project, organisatie of contactpersoon…',
      period: {
        all: 'Alle periodes',
        d7:  'Laatste 7 dagen',
        d30: 'Laatste 30 dagen',
        d90: 'Laatste 90 dagen',
      },
      active_on:       'Actief op',
      active_on_title: 'Toon aanvragen waarvan de projectperiode deze datum omvat',
      add_btn:    'Aanvraag toevoegen',
      import_pdf: 'Importeer PDF-aanvraag',
    },
    add_request: {
      title:                 'Aanvraag handmatig toevoegen',
      lede:                  'Voer de gegevens van de aanvrager in. Het systeem stuurt automatisch een bevestigingsmail naar het opgegeven adres en doorloopt vervolgens hetzelfde proces als bij een aanvraag via de website.',
      label_org:             'Organisatie aanvrager',
      ph_org:                'Bijv. Bouwbedrijf Janssen BV',
      label_project:         'Projectnaam',
      ph_project:            'Bijv. Renovatie Marktstraat',
      label_contact_name:    'Contactpersoon',
      label_email:           'E-mailadres',
      label_phone:           'Telefoon',
      label_point:           'Stroompunt',
      label_points:          'Stroompunten',
      point_placeholder:     '+ Voeg stroompunt toe…',
      connector_lede:        'Aansluiter - wie voert de fysieke aansluiting uit? (kan andere persoon zijn)',
      copy_from_org:         'Kopieer van aanvrager',
      label_connector_name:  'Naam aansluiter',
      label_connector_email: 'E-mail aansluiter',
      label_connector_phone: 'Telefoon aansluiter',
      label_start:           'Startdatum',
      label_end:              'Einddatum',
      label_current_a:       'Max. stroom (A)',
      ph_current_a:          'bv. 63',
      label_connector:       'Type aansluiting',
      connector_ph:          'Kies een type…',
      connector_unknown:     'Onbekend',
      label_note:            'Toelichting (intern, optioneel)',
      ph_note:               'Bijvoorbeeld: telefonisch aangevraagd op 28 april via stadsbeheer.',
      submit:                'Aanvraag toevoegen & bevestigingsmail versturen',
      err_dates:             'Einddatum moet na startdatum liggen.',
      err_no_points:         'Kies minstens één stroompunt.',
      err_save:              'Aanvraag opslaan mislukt.',
    },
    request_status: {
      new:                'Nieuw',
      signing:            'Ondertekening',
      account_creation:   'Account aanmaken',
      rejected:           'Afgewezen',
      ready_for_install:  'Klaar voor installatie',
      in_progress:        'In uitvoering',
      completed:          'Afgesloten',
    },
    applications: {
      title:           'Aanmeldingen',
      sub:             'Inkomende aanmeldingen van organisaties die zich willen aansluiten op het platform. Goedkeuren maakt direct een organisatie + organisatie-account aan en verstuurt een welkomstmail.',
      empty:           'Geen aanmeldingen voor deze status.',
      err_load:        'Aanmeldingen laden mislukt.',
      filter_all:       'Alle statussen',
      filter_pending:   'Open',
      filter_approved:  'Goedgekeurd',
      filter_rejected:  'Afgewezen',
      review_action:   'Beoordelen',
      status_pending:  'Open',
      status_approved: 'Goedgekeurd',
      status_rejected: 'Afgewezen',
      col: {
        organisation: 'Organisatie',
        contact:      'Contactpersoon',
        email:        'E-mail',
        phone:        'Telefoon',
        message:      'Bericht',
        status:       'Status',
        submitted:    'Ingediend',
      },
      section_review:    'Beoordeling',
      section_approve:   'Goedkeuren - organisatie + organisatie-account aanmaken',
      approve_explainer: 'Bij goedkeuring wordt automatisch een organisatie aangemaakt op basis van de organisatienaam in de aanvraag, en een organisatie-account met een welkomstmail naar de aanvrager.',
      section_reject:    'Afwijzen',
      reviewed_by:       'Beoordeeld door',
      reviewed_at:       'Beoordeeld op',
      approved_organization: 'Goedgekeurd voor organisatie',
      label_organization:    'Organisatie',
      organization_placeholder: '- Kies een organisatie -',
      no_organizations:      'Geen organisaties beschikbaar - maak er eerst een aan onder Organisaties.',
      label_note:        'Notitie (optioneel)',
      note_placeholder:  'Bijvoorbeeld: contact gehad op 4 mei, partnerovereenkomst getekend.',
      label_reason:      'Reden van afwijzing',
      reason_placeholder:'Wordt opgeslagen voor de audittrail.',
      action_approve:    'Goedkeuren & welkomstmail versturen',
      action_reject:     'Afwijzen',
      confirm_reject:    'Aanvraag definitief afwijzen?',
      err_pick_organization: 'Selecteer eerst een organisatie.',
      err_reason_required:'Geef een reden van afwijzing op.',
      err_approve:       'Goedkeuren mislukt.',
      err_reject:        'Afwijzen mislukt.',
    },
    contact_messages: {
      title:           'Contactberichten',
      sub:             'Berichten ingediend via het publieke contactformulier op /contact.html. Markeer als gelezen wanneer u ze verwerkt heeft, of als afgehandeld zodra de zaak gesloten is.',
      empty:           'Geen berichten voor deze status.',
      err_load:        'Berichten laden mislukt.',
      err_action:      'Actie mislukt.',
      err_delete:      'Verwijderen mislukt.',
      filter_all:       'Alle statussen',
      filter_new:       'Nieuw',
      filter_read:      'Gelezen',
      filter_resolved:  'Afgehandeld',
      review_action:   'Bekijken',
      status_new:       'Nieuw',
      status_read:      'Gelezen',
      status_resolved:  'Afgehandeld',
      col: {
        contact:      'Contact',
        organisation: 'Organisatie',
        email:        'E-mail',
        phone:        'Telefoon',
        topic:        'Onderwerp',
        message:      'Bericht',
        status:       'Status',
        submitted:    'Ingediend',
      },
      section_handling:  'Behandeld door',
      read_by:           'Gelezen door',
      read_at:           'Gelezen op',
      action_reply:      'Beantwoorden →',
      action_mark_read:  'Markeer als gelezen',
      action_resolve:    'Markeer als afgehandeld',
      confirm_delete:    'Bericht definitief verwijderen?',
    },
    request_drawer: {
      section_booking:       'Booking',
      section_charging:      'Aanvullende gegevens laadstation',
      field_charging_card:   'Bouwstroom-laadpas aanvragen',
      field_adapter:         'Adapter nodig',
      field_fenced:          'Binnen de hekken / afgesloten',
      section_billing:          'Facturatie',
      field_billing_name:       'Factuurnaam',
      field_billing_email:      'Factuur e-mail',
      field_billing_address:    'Factuuradres',
      field_billing_vat:        'Btw-/KVK-nummer',
      field_billing_reference:  'Referentie / inkoopordernummer',
      section_area:          'Getekend gebied',
      area_view_exact:       'Bekijk getekend gebied ↗',
      area_view_center:      'Open midden in Google Maps ↗',
      area_corners:          '{n} hoekpunten',
      section_requester:     'Aanvrager',
      section_connector:     'Aansluiter',
      section_notes:         'Notities',
      section_documents:     'Documenten',
      section_workflow:      'Workflow',
      section_signing:       'Ondertekening',
      section_approvals:     'Goedkeuringen (AC-laadpaal)',
      section_account:       'Account aanmaken',
      section_install_party: 'Installatiepartij',
      section_final_go:      'Finale bevestiging',
      section_audit:         'Audittrail',
      section_add_note:      'Notitie toevoegen',
      workflow_hint:         'Klik op een stap om de status te wijzigen.',
      workflow_current:      'Huidige status',
      workflow_clickable:    'Klik om naar deze status te gaan',
      field_name:        'Naam',
      field_email:       'E-mail',
      field_phone:       'Telefoon',
      field_owner:       'Organisatie',
      field_submitted:   'Ingediend',
      internal:          'Intern',
      download:          'Bekijken',
      // Workflow actions - keys match RequestStatus values from the backend.
      action_approved:           'Goedkeuren',
      action_rejected:           'Afwijzen',
      action_awaiting_signature: 'Naar ondertekening',
      action_ready_for_install:  'Klaar voor installatie',
      action_in_progress:        'Markeren als gestart',
      action_completed:          'Afsluiten',
      confirm_rejected:   'Aanvraag afwijzen? Dit verstuurt een afwijzingsmail aan de aanvrager.',
      confirm_completed:  'Aanvraag afsluiten? Dit kan niet ongedaan worden gemaakt.',
      action_delete:      'Aanvraag verwijderen',
      confirm_delete:     'Aanvraag definitief verwijderen? Dit verwijdert de aanvraag en de bijbehorende reserveringen onherstelbaar.',
      err_delete:         'Verwijderen mislukt.',
      err_transition:     'Statuswijziging mislukt.',
      err_note:           'Notitie opslaan mislukt.',
      // Note form
      note_placeholder:   'Schrijf een korte notitie…',
      note_internal:      'Alleen intern zichtbaar',
      note_submit:        'Notitie toevoegen',
      edit_btn:           'Aanvraag bewerken',
      edit_title:         'Aanvraag bewerken',
      edit_lede:          'Pas de gegevens van de aanvraag aan. De aanvrager (en aansluiter) ontvangt automatisch een e-mail met de wijzigingen.',
      edit_submit:        'Opslaan & aanvrager mailen',
      edit_err:           'Bewerken mislukt.',
    },
    signing: {
      mode_label:           'Modus',
      mode_inhouse:         'In-house tekenen',
      mode_skipped:         'Overslaan (geen ondertekening vereist)',
      guideline_label:      'Richtlijn (PDF)',
      guideline_placeholder:'- Kies een richtlijn -',
      signer_label:         'Ontvanger (e-mail aansluiter)',
      send:                 'Verstuur ondertekenlink',
      send_skipped:         'Markeer als overgeslagen',
      resend:               'Opnieuw versturen',
      revoke:               'Intrekken',
      skipped_label:        'Overgeslagen door admin - geen ondertekening vereist.',
      no_session:           'Nog geen ondertekensessie gestart.',
      required_badge:       'Verplicht',
      optional_badge:       'Optioneel',
      required_label:       'Verplicht voor verdere voortgang',
      required_help:        'Bij uitvinken telt deze ondertekening niet mee voor de drempel naar "Klaar voor installatie".',
      history_intro:        'Aansluiter ({email}) heeft eerder {count} richtlijn(en) ondertekend:',
      history_on_request:   'aanvraag {requestId} · {project} · {at}',
      history_recent_badge: '≤ 12 mnd',
      history_old_badge:    '> 12 mnd',
      mode_choice_label:    'Ondertekeningsmethode',
      state_sent:           'Verstuurd op {at} naar {email} - wacht op ondertekening.',
      state_opened:         'Geopend {count}× - laatst op {at}.',
      state_accepted:       'Geaccepteerd op {at}.',
      state_revoked:        'Ingetrokken op {at}.',
      expires_at:           'Verloopt op {at}.',
      no_guidelines:        'Geen richtlijnen beschikbaar - upload er eerst een onder Richtlijnen.',
      confirm_revoke:       'Ondertekenlink intrekken? Een nieuwe sessie kan daarna gestart worden.',
      certificate:          'Download certificaat',
      err_pick_guideline:   'Selecteer eerst een richtlijn.',
      err_send:             'Versturen mislukt.',
      err_resend:           'Opnieuw versturen mislukt.',
      err_revoke:           'Intrekken mislukt.',
      err_certificate:      'Certificaat downloaden mislukt.',
    },
    approvals: {
      kind_operator:        'Beheerder laadpaal',
      kind_municipality:    'Gemeente',
      label_email:          'E-mail',
      label_contact_name:   'Contactpersoon (optioneel)',
      send:                 'Verstuur',
      resend:               'Opnieuw versturen',
      force_approve:        'Forceer goedgekeurd',
      force_reject:         'Forceer afgewezen',
      force_note_label:     'Toelichting (verplicht)',
      force_confirm:        'Status forceren? Deze actie wordt vastgelegd in de audittrail.',
      state_pending:        'In afwachting - verloopt {at}.',
      state_approved:       'Goedgekeurd op {at}.',
      state_rejected:       'Afgewezen op {at}.',
      with_note:            'Toelichting: {note}',
      err_email:            'Vul een geldig e-mailadres in.',
      err_send:             'Versturen mislukt.',
      err_resend:           'Opnieuw versturen mislukt.',
      err_force:            'Forceren mislukt.',
    },
    account: {
      intro:           'Maak een account aan voor de aanvrager in de app voordat de installatie van start gaat.',
      created_label:   'Account aangemaakt',
      confirm:         'Bevestig',
      skip:            'Sla over',
      confirm_skip:    'Weet je zeker dat je deze stap wilt overslaan? De aanvraag gaat door naar "Klaar voor installatie" zonder dat er een account is aangemaakt.',
      state_created:   'Account aangemaakt op {at} door {by}.',
      state_skipped:   'Stap overgeslagen op {at} door {by}.',
      not_yet:         'Wacht tot de ondertekening rond is.',
      err_unchecked:   'Vink eerst "Account aangemaakt" aan, of klik Sla over.',
      err_save:        'Opslaan mislukt.',
    },
    install_party: {
      installer_label:       'Installatiepartij',
      installer_placeholder: '- Kies een partij -',
      mode_label:            'Modus',
      mode_notify_only:      'Alleen melding',
      mode_key_delivery:     'Sleuteloverdracht',
      template_label:        'E-mail template',
      template_default:      '- Standaard (op basis van organisatie) -',
      template_scope_global: 'algemeen',
      send:                  'Verstuur instructie',
      resend:                'Opnieuw versturen',
      state_sent:            '{name} ({mode}) - verstuurd op {at}.',
      not_yet:               'Nog niet geïnstrueerd. Beschikbaar zodra de aanvraag op "Klaar voor installatie" staat.',
      no_parties:            'Geen installatiepartijen voor deze organisatie - voeg er eerst een toe onder Installatiepartijen.',
      err_pick:              'Selecteer eerst een installatiepartij.',
      err_send:              'Versturen mislukt.',
      err_resend:            'Opnieuw versturen mislukt.',
    },
    final_go: {
      send:        'Verstuur finale go-mail',
      state_sent:  'Verstuurd op {at}.',
      not_yet:     'Stuur eerst de installatiepartij-instructie.',
      err_send:    'Versturen mislukt.',
    },
    audit: {
      kind_note:           'Notitie',
      kind_audit:          'Admin-actie',
      kind_signing_event:  'Signer-event',
      actor_signer:        'aansluiter',
      empty:               'Geen activiteit nog.',
      err_load:            'Audittrail laden mislukt.',
    },
    scan_projects: {
      title:        'Energie-scan projecten',
      sub:          'Per bouwproject zoeken naar bedrijven, laadpalen en gemeente-aansluitingen die als stroomvoorziening kunnen dienen. Vervangt de standalone Energiescan-tool.',
      new_btn:      'Nieuw project',
      search_ph:    'Zoek op nummer, naam, opdrachtgever of projectleider…',
      empty:        'Nog geen scan-projecten. Klik op "Nieuw project" om er één aan te maken.',
      col: {
        number:        'Nr.',
        name:          'Projectnaam',
        client:        'Opdrachtgever',
        project_lead:  'Projectleider',
        status:        'Status',
        updated:       'Laatst gewijzigd',
      },
      status: {
        concept:     'Concept',
        in_progress: 'Lopend',
        afgerond:    'Afgerond',
      },
      status_all:   'Alle statussen',
      map_aria:     'Overzichtskaart van alle scan-projecten',
      map_count:    '{n} projecten op de kaart',
      err_load:     'Projecten laden mislukt.',
      err_delete:   'Verwijderen mislukt.',
      delete_confirm: 'Weet u zeker dat u project "{label}" wilt verwijderen?',
    },
    scan_project: {
      title_new:           'Nieuw scan-project',
      title_edit:          'Scan-project bewerken',
      back_to_list:        '← Terug naar overzicht',
      section_project:     'Project',
      section_client:      'Opdrachtgever',
      section_location:    'Locatie',
      section_description: 'Omschrijving',
      label_number:        'Projectnummer',
      label_name:          'Projectnaam',
      label_client_name:   'Opdrachtgever (naam)',
      label_client_type:   'Type opdrachtgever',
      label_client_org:    'Gekoppelde organisatie (optioneel)',
      label_project_lead:  'Projectleider NRG',
      label_contact:       'Contactpersoon',
      label_planned_start: 'Geplande start',
      label_delivery_date: 'Datum oplevering',
      label_address:       'Adres / werklocatie',
      label_latitude:      'Breedtegraad',
      label_longitude:     'Lengtegraad',
      label_short:         'Korte omschrijving',
      label_workarea:      'Inleiding werkgebied',
      label_workdesc:      'Beschrijving werkzaamheden',
      label_status:        'Status',
      number_hint:         'Auto-gegenereerd in JJNNN-formaat. Klik om aan te passen.',
      client_org_ph:       '- Geen koppeling -',
      client_type_ph:      'bv. Gemeente, Provincie, Aannemer',
      save_btn:            'Opslaan',
      saved:               'Opgeslagen.',
      err_load:            'Project laden mislukt.',
      err_save:            'Opslaan mislukt.',
      err_required_name:   'Projectnaam is verplicht.',
      geocode_btn:         'Zoek op kaart',
      map_aria:            'Kaart van het projectgebied',
      panel_picker:        'Locatie kiezen',
      panel_search:        'Bedrijven zoeken',
      panel_saved:         'Toegevoegd aan project',
      picker_btn:          'Kies op kaart',
      picker_btn_active:   'Klik op de kaart…',
      picker_hint:         'Klik op de kaart om de projectlocatie te zetten. Het adres wordt automatisch opgehaald als er een Google API-key is.',
      radius_label:        'Radius',
      keyword_label:       'Trefwoord (optioneel)',
      keyword_ph:          'bv. restaurant, café',
      search_btn:          'Zoek',
      search_btn_busy:     'Zoeken…',
      search_hint_save_first: 'Sla het project eerst op om bedrijven in de buurt te kunnen zoeken.',
      search_hint_no_anchor:  'Zet eerst de projectlocatie (klik "Kies op kaart" of typ lat/lng).',
      search_status_hits:  '{count} resultaten gevonden binnen {radius} m.',
      search_status_zero:  'Geen resultaten binnen {radius} m.',
      saved_empty:         'Nog niets toegevoegd.',
      err_search:          'Zoeken mislukt.',
      err_search_no_key:   'Google Places API is niet geconfigureerd op de server.',
      err_geocode:         'Adres niet gevonden.',
      err_reverse:         'Geen adres bij dit punt.',
      err_add_station:     'Toevoegen mislukt.',
      add_to_project_btn:  'Voeg toe aan project',
      already_added:       'Al toegevoegd',
      saved_pill_draft:    'concept',
      saved_pill_public:   'publiek',
      saved_pill_admin:    'alleen admin',
      promote_btn:           'Maak publiek',
      promote_confirm_title: 'Publiceren bevestigen',
      promote_confirm:       '"{label}" wordt zichtbaar op de publieke kaart. Doorgaan?',
      promote_confirm_btn:   'Publiceren',
      err_promote:           'Publiceren mislukt.',
      open_other_project_btn:'Open project',
      basemap_light:          'Kaart',
      basemap_satellite:      'Satelliet',
      overlay_saved:          'Toegevoegd aan dit project',
      overlay_scouts:         'Zoekresultaten',
      overlay_power:          'Power stations',
      overlay_charging:       'Laadpunten',
      overlay_other_projects: 'Andere scan-projecten',
      label_powerstation:     'Power station',
      label_charging_ac:      'Laadpunt (AC)',
      label_charging_dc:      'Laadpunt (DC)',
      unassign_btn:           'Verwijder uit project',
      unassign_confirm_title: 'Verwijderen uit project bevestigen',
      unassign_confirm:       '"{label}" wordt losgekoppeld van dit scan-project. De indirect station blijft bestaan en kun je later opnieuw koppelen of via Indirect stations beheren. Doorgaan?',
      unassign_confirm_btn:   'Verwijderen uit project',
      err_unassign:           'Verwijderen uit project mislukt.',
    },
  },
};

export const en = {
  /* ============================================================
     Admin portal
     ============================================================ */
  admin: {
    bar: {
      portal:         'Admin portal',
      menu_label:     'Admin menu',
      back_to_public: 'Back to public site',
      logout:         'Sign out',
    },
    nav: {
      groups: {
        operations:   'Operations',
        power_points: 'Power points',
        management:   'Management',
      },
      items: {
        dashboard:            'Dashboard',
        requests:             'Requests',
        admin_map:            'Admin map',
        power_stations:       'Power stations',
        indirect_stations:    'Indirect stations',
        ac_chargers:          'AC chargers',
        dc_chargers:          'DC chargers',
        water_points:         'Water points',
        point_usage:          'Usage history',
        scan_projects:        'Energy scans',
        organizations:        'Organisations',
        applications:         'Sign-ups',
        contact_messages:     'Contact messages',
        installation_parties: 'Installation parties',
        email_templates:      'Email templates',
        guidelines:           'Guidelines',
        users:                'Users',
        settings:             'Settings',
        audit_logs:           'Audit logs',
      },
    },
    actions: {
      edit:    'Edit',
      delete:  'Delete',
      cancel:  'Cancel',
      save:    'Save',
      loading: 'Loading…',
      empty:   'No results.',
      pager_prev: '← Prev',
      pager_next: 'Next →',
      col_actions: 'Actions',
    },
    confirm: {
      delete_user:             'Delete {email}?',
      delete_power_station:    'Delete power station "{label}"?',
      delete_indirect_station: 'Delete indirect station "{label}"?',
      delete_water_point:      'Delete water point "{label}"?',
      delete_charging_station: 'Delete charging station "{label}"? It may reappear on the next import.',
      modal_title_delete:     'Confirm deletion',
      modal_confirm_delete:   'Delete',
    },
    dashboard: {
      title:           'Welcome',
      sub:             'Pick a section below to continue.',
      cards: {
        requests:             { title: 'Requests',             sub: 'Review and approve incoming requests.' },
        power_stations:       { title: 'Power stations',       sub: 'Add, edit, and bulk-import the points listed on the map.' },
        installation_parties: { title: 'Installation parties', sub: 'Companies authorised to open power cabinets per organisation.' },
        email_templates:      { title: 'Email templates',      sub: 'Customise transactional emails by organisation and point type.' },
        organizations:        { title: 'Organisations',        sub: 'Manage the organisations that own power points.' },
        applications:         { title: 'Sign-ups',             sub: 'Review incoming sign-ups from new organisations.' },
        users:                { title: 'Users',                sub: 'Platform admins and organisation accounts.' },
        settings:             { title: 'Settings',             sub: 'Tariff margin, importer schedule, and other runtime knobs.' },
        audit_logs:           { title: 'Audit logs',           sub: 'Who changed what, and when.' },
      },
    },
    users: {
      title:     'Users',
      sub:       'Platform admins, operators, and organisation accounts. New users get a welcome email with a temporary password.',
      new_btn:   'New user',
      search_ph: 'Search by email or name…',
      empty:     'No users yet.',
      col: {
        email:   'Email',
        name:    'Name',
        role:    'Role',
        blocked: 'Blocked',
      },
      yes: 'yes',
      no:  'no',
    },
    user_form: {
      title_new:           'New user',
      title_edit:          'Edit user',
      section_identity:    'Identity',
      section_access:      'Access & permissions',
      label_email:         'Email',
      label_name:          'Name',
      label_role:          'Role',
      label_owner:         'Organisation',
      label_blocked:       'Blocked',
      owner_placeholder:   '- Choose an organisation -',
      owner_hint:          "Organisation users only see rows belonging to their own organisation.",
      role_platform_admin:    'Platform admin (NRG, full rights)',
      role_organization:      'Organisation (per organisation)',
      submit_new:          'Create user',
      submit_edit:         'Save changes',
      saved:               'Saved.',
      created_html:        'User {email} created - a welcome email with a temporary password has been sent.',
      err_load:            'Failed to load user.',
      err_save:            'Save failed.',
    },
    power_stations: {
      title:     'Power stations',
      sub:       'Manage all fixed power points on the map. Edit location, capacity and connectors, or add a new point.',
      new_btn:   'New power station',
      search_ph: 'Search by ID, address, organisation…',
      empty:     'No power stations yet.',
      col: {
        row_id:     'ID',
        id:         'Power station ID',
        address:    'Address',
        city:       'City',
        capacity:   'Capacity',
        connectors: 'Connectors',
      },
    },
    power_station_form: {
      title_new:    'New power station',
      title_edit:   'Edit power station',
      submit_new:   'Create power station',
      submit_edit:  'Save changes',
      saved:        'Power station saved.',
      created:      'Power station created.',
      err_load:     'Failed to load power station.',
      err_save:     'Save failed.',
      images_placeholder_title: 'Images',
      images_placeholder_body:  'Save the power station first. After that you can upload photos and reorder them here.',
      images_confirm_delete:    'Delete this image?',
      images_pick_label:        'Add photos (optional)',
      images_pick_hint:         'JPEG, PNG, or WebP. Maximum 5 MB per file. The first image is shown as the cover on the public map.',
      uploading_progress:       'Uploading photo {i} of {n}…',
      upload_partial:           'Power station was created, but one or more photos failed to upload. Open the edit page to retry.',
    },
    indirect_stations: {
      title:     'Indirect stations',
      sub:       'Manage indirect power points on the map. Edit location, capacity and connectors, or add a new point.',
      new_btn:   'New indirect station',
      search_ph: 'Search by ID, address, organisation…',
      empty:     'No indirect stations yet.',
      col: {
        id:         'Indirect station ID',
        address:    'Address',
        city:       'City',
        capacity:   'Capacity',
        connectors: 'Connectors',
      },
    },
    indirect_station_form: {
      title_new:  'New indirect station',
      title_edit: 'Edit indirect station',
      scouting_context: 'Energy-scan origin',
      scan_project_link: 'Added from project',
      google_place_id:   'Google place ID',
    },
    station_form: {
      connector_add_ph:  '+ Add another type…',
      connector_add_btn: 'Add',
    },
    scouting_status: {
      unset:                 '- No scouting status -',
      benaderd:              'Contacted',
      positief:              'Positive response',
      locatiebezoek_gepland: 'Site visit planned',
      locatiebezoek_gehad:   'Site visit done',
      negatief:              'Rejected / negative',
    },
    map: {
      title:               'Admin map - Admin portal',
      sidebar_title:       'Admin map',
      points_with_visibility: 'points · private overview - all visibilities',
      search_placeholder:  'Search by name, city, or address…',
      filter_kind:         'Connection type',
      filter_visibility:   'Visibility',
      filter_source:       'Source',
      visibility: {
        public:     'Public',
        admin_only: 'Admin only',
        draft:      'Draft',
      },
      source: {
        all:    'All',
        manual: 'Manual',
        csv:    'CSV',
        api:    'API',
        scout:  'Scouted',
      },
      banner:        'Private overview - only visible to signed-in admins',
      aria_label:    'Admin map of the country showing every power point',
      detail_aria:   'Power-point details',
      detail: {
        btn_edit:           'Edit in admin',
        from_scan_project:  'Added from Energy-scan',
      },
      vis_selector: {
        label: 'Visibility',
        sub: {
          public:     'Everyone sees this point on the public map',
          admin_only: 'Hidden from the public map; visible internally',
          draft:      'Work-in-progress; only visible to me',
        },
        confirm_demote: 'Hide this point from the public map? Existing bookings stay valid - only the visibility for new visitors changes.',
        err_change:     'Failed to change visibility.',
      },
      oda: {
        cta_title:      'No ODA link.',
        cta_body:       'With an ODA mandate we can read the actual quarter-hour values from the grid operator and show how many kWh are free during the day and at night.',
        cta_btn:        '+ Link ODA',
        linked_title:   'ODA link - spare capacity',
        prompt_title:   'Link ODA',
        prompt:         'Enter the 18-digit EAN code of the connection.',
        link_btn:       'Link',
        invalid:        'Invalid EAN code - enter exactly 18 digits.',
        change_btn:     'Change EAN',
        unlink_btn:     'Unlink',
        confirm_unlink: 'Remove the ODA link?\n\nThe EAN code disappears from this point. The mandate stays active at EDSN until you also revoke it there.',
        err_change:     'Failed to save the EAN code.',
        sync_btn:       'Refresh',
        loading:        'Loading capacity data…',
        err_load:       'Failed to load capacity data. Try again later.',
        no_data:        'No readings in this window.',
        no_limit:       'No fuse type known for this connection - free capacity cannot be determined.',
        day:            'Day',
        night:          'Night',
        figure_label:   'Avg. spare capacity',
        unit:           'kWh / day',
        used:           'Used',
        free:           'Free',
        row_limit:      'Effective limit',
        row_contracted: 'Contracted available',
        row_used:       'Average used',
        row_window:     'Window length',
        hours:          'hours',
        based_on:       'Based on readings from',
        days:           'days',
      },
    },
    water_points: {
      title:     'Water points',
      sub:       'Manage drinking-water points shown on the map alongside power points.',
      new_btn:   'New water point',
      search_ph: 'Search by street or type…',
      empty:     'No water points yet.',
      col: {
        type:      'Type',
        street:    'Street',
        number:    'Number',
        latitude:  'Latitude',
        longitude: 'Longitude',
      },
    },
    water_point_form: {
      title_new:    'New water point',
      title_edit:   'Edit water point',
      section_location: 'Location',
      section_status:   'Status',
      label_type:       'Type',
      label_street:     'Street name',
      label_number:     'House number',
      label_latitude:   'Latitude',
      label_longitude:  'Longitude',
      label_status:     'Status',
      submit_new:       'Create water point',
      submit_edit:      'Save changes',
      saved:            'Water point saved.',
      created:          'Water point created.',
      err_load:         'Failed to load water point.',
      err_save:         'Save failed.',
    },
    charging_stations: {
      title_ac:  'AC charging stations',
      title_dc:  'DC fast chargers',
      sub:       'The daily import is the source of truth - local edits would be overwritten on the next run, so create + edit are not exposed. You can change Status per row (the importer leaves it alone) and delete to drop stale rows.',
      search_ph: 'Search by ID, name, address, city, operator…',
      empty:     'No charging stations yet.',
      col: {
        location_id: 'ID',
        name:        'Name',
        operator:    'Operator',
        address:     'Address',
        city:        'City',
        layers:      'Layers',
        status:      'Status',
      },
    },
    point_status: {
      available:      'Available',
      maintenance:    'Maintenance',
      out_of_service: 'Out of service',
    },
    organization: {
      label:      'Organisation',
      unassigned: '- Unassigned -',
    },
    point_usage: {
      title:         'Usage history',
      sub:           'How often and for what points are used. Only approved bookings count.',
      search_ph:     'Search by point, city, project or requester…',
      empty:         'No usage found in this period.',
      load_err:      'Could not load the usage history.',
      not_found:     'This point does not exist or is not part of your organisation.',
      back:          '← All points',
      pending:       '{n} under review',
      manual:        'Manual block',
      kind: {
        all:             'All types',
        PowerStation:    'Power station',
        IndirectStation: 'Indirect station',
        ChargingStation: 'Charging station',
        WaterPoint:      'Water point',
      },
      period: {
        m12:       'Last 12 months',
        m24:       'Last 24 months',
        this_year: 'This year',
        last_year: 'Last year',
      },
      sort: {
        days:   'Most used',
        recent: 'Recently used',
        name:   'Name',
      },
      col: {
        point:     'Point',
        bookings:  'Bookings',
        days:      'Days',
        occupancy: 'Occupancy',
        last:      'Last used',
        next:      'Next booking',
        projects:  'Projects',
      },
      kpi: {
        days:      'Days booked',
        occupancy: 'Occupancy',
        bookings:  'Bookings',
        next:      'Next booking',
      },
      chart_title:   'Days booked per month',
      history_title: 'Booking history',
      history_sub:   'Every booking on this point, newest first. Not limited to the selected period.',
      history_empty: 'This point has never been booked.',
      hcol: {
        period:    'Period',
        days:      'Days',
        project:   'Project',
        requester: 'Requester',
        status:    'Status',
        request:   'Request',
      },
      status: {
        confirmed: 'Confirmed',
        tentative: 'Under review',
        upcoming:  'Planned',
      },
    },
    audit_logs: {
      title:     'Audit logs',
      sub:       'Append-only record of every admin-side mutation. Newest first.',
      search_ph: 'Search by actor email or resource id…',
      empty:     'No audit events.',
      col: {
        timestamp: 'Timestamp (UTC)',
        actor:     'Actor',
        action:    'Action',
        resource:  'Resource',
        details:   'Details',
      },
    },
    app_settings: {
      title: 'Settings',
      sub:   'Edit existing values inline. New settings are added by deploying code that needs them; the SQL seed script inserts the defaults.',
      empty: 'No settings yet.',
      col: {
        name:  'Name',
        value: 'Value',
      },
    },
    organizations: {
      title:          'Organisations',
      sub:            'Organisations that own power points - municipalities, port authorities, NRG. Organisation users are tied to one organisation and only see rows belonging to it.',
      new_btn:        'Add organisation',
      title_new:      'Add organisation',
      title_edit:     'Edit organisation',
      lede:           'An organisation owns power points. Organisation users are bound through their role to exactly one organisation.',
      label_id:       'ID',
      hint_id:        'Short key - lowercase, no spaces. Cannot be changed after creation.',
      ph_id:          'e.g. amsterdam',
      label_name:     'Name',
      ph_name:        'e.g. City of Amsterdam',
      label_email:    'Contact email (optional)',
      label_country:  'Country (ISO 2)',
      empty:          'No organisations yet.',
      delete_confirm: 'Are you sure you want to delete "{label}"? Existing rows referencing this organisation will be unassigned.',
      col: {
        id:      'ID',
        name:    'Name',
        email:   'Contact email',
        country: 'Country',
        created: 'Created',
      },
      err_id:        'ID is required.',
      err_name:      'Name is required.',
      err_country:   'Country is required.',
      err_duplicate: 'An organisation with this ID already exists.',
      err_save:      'Save failed.',
      err_delete:    'Delete failed.',
      err_load:      'Failed to load organisations.',
    },
    guidelines: {
      title:           'Guidelines',
      sub:             'PDF guidelines that connectors must sign before a connection activity can be scheduled. Global guidelines are available to every organisation.',
      new_btn:         'Upload guideline',
      include_archived:'Show archived',
      empty:           'No guidelines uploaded yet.',
      global:          'Global',
      version_label:   'v{version}',
      uploaded_by:     'Uploaded by {by} · {at}',
      archived_label:  'Archived',
      modal_new_title: 'Upload guideline',
      modal_replace_title: 'Upload new version',
      modal_replace_lede:  'The current version will be archived and replaced by this new PDF. Past signing sessions keep referencing the earlier version.',
      label_name:      'Name',
      ph_name:         'e.g. Connection protocol for power cabinets',
      label_language:  'Language',
      ph_language:     'en, nl, …',
      label_owner:     'Organisation',
      owner_global:    '- Global (all organisations) -',
      label_file:      'PDF file',
      pdf_only_hint:   'application/pdf only, max 20 MB.',
      action_download: 'View PDF',
      action_replace:  'Replace',
      action_signers:  'Show signers',
      action_resend_signer: 'Send again',
      resend_confirm:    'Send this guideline again to {email} for request {request}? A fresh signing link will be created.',
      resend_sent:       'Sent',
      err_resend_signer: 'Re-send failed.',
      action_archive:  'Archive',
      action_unarchive:'Unarchive',
      action_delete:   'Delete',
      col_signer:        'Signer',
      col_email:         'Email',
      col_organisation:  'Organisation',
      col_request:       'Request',
      col_accepted_at:   'Signed at',
      signers_empty:     'No signers yet for this version.',
      delete_confirm:  'Permanently delete "{label}"? This cannot be undone.',
      archive_confirm: 'Archive "{label}"? Connectors can no longer start new sessions with this version.',
      err_load:        'Failed to load guidelines.',
      err_name:        'Name is required.',
      err_file:        'Pick a PDF file.',
      err_save:        'Save failed.',
      err_replace:     'Replace failed.',
      err_archive:     'Archive failed.',
      err_delete:      'Delete failed.',
      err_signers_load:'Failed to load signers.',
    },
    installation_parties: {
      title:        'Installation parties',
      sub:          'Companies authorised to open a power cabinet on behalf of an owner. These appear as options in step 4 of the request workflow.',
      new_btn:      'Add party',
      title_new:    'Add party',
      title_edit:   'Edit party',
      lede:         'An installation party receives an email when a connection activity is scheduled at your power point - optionally with key-handover instructions.',
      label_owner:  'Organisation',
      label_name:   'Organisation / team name',
      label_email:  'Email',
      label_phone:  'Phone',
      label_notify_emails: 'Extra notification addresses (optional)',
      label_notes:  'Note (internal, optional)',
      ph_name:      'e.g. Bristol City Council Estates',
      ph_email:     'alerts@party.com',
      ph_notify_emails: 'council@bristol.gov.uk, estates@bristol.gov.uk',
      help_notify_emails: 'Get a copy whenever this party receives an instruction email.',
      add_email:    'Add',
      err_email_invalid: 'Enter a valid email address.',
      cc_prefix:    'Cc:',
      ph_notes:     'e.g. Pick up key on weekdays 8:00–16:00 at the town hall.',
      empty:        'No installation parties yet.',
      delete_confirm: 'Delete "{label}"?',
      err_name:     'Name is required.',
      err_owner:    'Select an owner.',
      err_save:     'Save failed.',
      err_delete:   'Delete failed.',
      err_load:     'Failed to load installation parties.',
    },
    requests: {
      title:    'All requests',
      sub:      'Overview of every request you can manage.',
      empty:    'No requests found.',
      err_load: 'Failed to load requests.',
      col: {
        id:       'Number',
        project:  'Project / organisation',
        point:    'Power points',
        period:   'Period',
        status:   'Status',
        submitted:'Submitted',
      },
      kpi: {
        total:   'Total',
        action:  'Awaiting action',
        review:  'Being processed',
        running: 'In progress',
      },
      search_ph: 'Search by request number, project, organisation, or contact…',
      period: {
        all: 'All periods',
        d7:  'Last 7 days',
        d30: 'Last 30 days',
        d90: 'Last 90 days',
      },
      active_on:       'Active on',
      active_on_title: 'Show requests whose project period includes this date',
      add_btn:    'Add request',
      import_pdf: 'Import PDF request',
    },
    add_request: {
      title:                 'Add request manually',
      lede:                  "Enter the requester's details. The system will automatically send a confirmation email to the address you provide, and the request follows the same workflow as one submitted via the website.",
      label_org:             "Requester's organisation",
      ph_org:                'e.g. Janssen Construction Ltd.',
      label_project:         'Project name',
      ph_project:            'e.g. Market Street renovation',
      label_contact_name:    'Contact person',
      label_email:           'Email',
      label_phone:           'Phone',
      label_point:           'Power point',
      label_points:          'Power points',
      point_placeholder:     '+ Add power point…',
      connector_lede:        'Connector - who performs the physical connection? (can be a different person)',
      copy_from_org:         'Copy from requester',
      label_connector_name:  'Connector name',
      label_connector_email: 'Connector email',
      label_connector_phone: 'Connector phone',
      label_start:           'Start date',
      label_end:              'End date',
      label_current_a:       'Max. current (A)',
      ph_current_a:          'e.g. 63',
      label_connector:       'Connection type',
      connector_ph:          'Choose a type…',
      connector_unknown:     'Unknown',
      label_note:            'Internal note (optional)',
      ph_note:               'e.g. Phoned in on 28 April via city services.',
      submit:                'Add request & send confirmation email',
      err_dates:             'End date must be after start date.',
      err_no_points:         'Pick at least one power point.',
      err_save:              'Failed to save the request.',
    },
    request_status: {
      new:                'New',
      signing:            'Signing',
      account_creation:   'Account creation',
      rejected:           'Rejected',
      ready_for_install:  'Ready for install',
      in_progress:        'In progress',
      completed:          'Completed',
    },
    applications: {
      title:           'Sign-ups',
      sub:             'Incoming sign-ups from organisations that want to join the platform. Approving creates the organisation + organisation account immediately and sends a welcome email.',
      empty:           'No sign-ups match this status.',
      err_load:        'Failed to load sign-ups.',
      filter_all:       'All statuses',
      filter_pending:   'Open',
      filter_approved:  'Approved',
      filter_rejected:  'Rejected',
      review_action:   'Review',
      status_pending:  'Open',
      status_approved: 'Approved',
      status_rejected: 'Rejected',
      col: {
        organisation: 'Organisation',
        contact:      'Contact person',
        email:        'Email',
        phone:        'Phone',
        message:      'Message',
        status:       'Status',
        submitted:    'Submitted',
      },
      section_review:    'Review',
      section_approve:   'Approve - create organisation + organisation account',
      approve_explainer: 'On approval an organisation is auto-created from the application\'s organisation name, plus an organisation account with a welcome email to the applicant.',
      section_reject:    'Reject',
      reviewed_by:       'Reviewed by',
      reviewed_at:       'Reviewed at',
      approved_organization: 'Approved for organisation',
      label_organization:    'Organisation',
      organization_placeholder: '- Choose an organisation -',
      no_organizations:      'No organisations available - create one first under Organisations.',
      label_note:        'Note (optional)',
      note_placeholder:  'e.g. spoke on 4 May, partner agreement signed.',
      label_reason:      'Reason for rejection',
      reason_placeholder:'Stored for the audit trail.',
      action_approve:    'Approve & send welcome email',
      action_reject:     'Reject',
      confirm_reject:    'Reject this application permanently?',
      err_pick_organization: 'Select an organisation first.',
      err_reason_required:'Provide a rejection reason.',
      err_approve:       'Approval failed.',
      err_reject:        'Rejection failed.',
    },
    contact_messages: {
      title:           'Contact messages',
      sub:             'Messages submitted via the public contact form on /contact.html. Mark as read once you have processed them, or as resolved when the case is closed.',
      empty:           'No messages match this status.',
      err_load:        'Failed to load messages.',
      err_action:      'Action failed.',
      err_delete:      'Delete failed.',
      filter_all:       'All statuses',
      filter_new:       'New',
      filter_read:      'Read',
      filter_resolved:  'Resolved',
      review_action:   'View',
      status_new:       'New',
      status_read:      'Read',
      status_resolved:  'Resolved',
      col: {
        contact:      'Contact',
        organisation: 'Organisation',
        email:        'Email',
        phone:        'Phone',
        topic:        'Subject',
        message:      'Message',
        status:       'Status',
        submitted:    'Submitted',
      },
      section_handling:  'Handled by',
      read_by:           'Read by',
      read_at:           'Read at',
      action_reply:      'Reply →',
      action_mark_read:  'Mark as read',
      action_resolve:    'Mark as resolved',
      confirm_delete:    'Permanently delete this message?',
    },
    request_drawer: {
      section_booking:       'Booking',
      section_charging:      'Additional charging-station details',
      field_charging_card:   'Wants construction charging card',
      field_adapter:         'Needs adapter',
      field_fenced:          'Within fences / closed off',
      section_billing:          'Billing',
      field_billing_name:       'Billing name',
      field_billing_email:      'Billing email',
      field_billing_address:    'Billing address',
      field_billing_vat:        'VAT / CoC number',
      field_billing_reference:  'Reference / PO number',
      section_area:          'Drawn area',
      area_view_exact:       'View drawn area ↗',
      area_view_center:      'Open centre in Google Maps ↗',
      area_corners:          '{n} corners',
      section_requester:     'Requester',
      section_connector:     'Connector',
      section_notes:         'Notes',
      section_documents:     'Documents',
      section_workflow:      'Workflow',
      section_signing:       'Signing',
      section_approvals:     'Approvals (AC charger)',
      section_account:       'Account creation',
      section_install_party: 'Installation party',
      section_final_go:      'Final go',
      section_audit:         'Audit timeline',
      section_add_note:      'Add a note',
      workflow_hint:         'Click a step to change the status.',
      workflow_current:      'Current status',
      workflow_clickable:    'Click to move to this status',
      field_name:        'Name',
      field_email:       'Email',
      field_phone:       'Phone',
      field_owner:       'Organisation',
      field_submitted:   'Submitted',
      internal:          'Internal',
      download:          'Open',
      action_approved:           'Approve',
      action_rejected:           'Reject',
      action_awaiting_signature: 'Send to signing',
      action_ready_for_install:  'Ready for install',
      action_in_progress:        'Mark as started',
      action_completed:          'Close',
      confirm_rejected:   'Reject this request? This sends a rejection email to the requester.',
      confirm_completed:  'Close this request? This cannot be undone.',
      action_delete:      'Delete request',
      confirm_delete:     'Permanently delete this request? This irreversibly removes the request and its bookings.',
      err_delete:         'Delete failed.',
      err_transition:     'Status change failed.',
      err_note:           'Failed to save the note.',
      note_placeholder:   'Write a short note…',
      note_internal:      'Only visible internally',
      note_submit:        'Add note',
      edit_btn:           'Edit request',
      edit_title:         'Edit request',
      edit_lede:          'Update the request details. The requester (and connector) is automatically emailed about the changes.',
      edit_submit:        'Save & email requester',
      edit_err:           'Edit failed.',
    },
    signing: {
      mode_label:            'Mode',
      mode_inhouse:          'In-house signing',
      mode_skipped:          'Skip (no signature required)',
      guideline_label:       'Guideline (PDF)',
      guideline_placeholder: '- Pick a guideline -',
      signer_label:          'Recipient (connector email)',
      send:                  'Send signing link',
      send_skipped:          'Mark as skipped',
      resend:                'Resend',
      revoke:                'Revoke',
      skipped_label:         'Skipped by admin - no signature required.',
      no_session:            'No signing session yet.',
      required_badge:        'Required',
      optional_badge:        'Optional',
      required_label:        'Required to advance the workflow',
      required_help:         'When unchecked this signature is informational - the request can still advance to "Ready for install" without it.',
      history_intro:         'Connector ({email}) has previously signed {count} guideline(s):',
      history_on_request:    'request {requestId} · {project} · {at}',
      history_recent_badge:  '≤ 12 mo',
      history_old_badge:     '> 12 mo',
      mode_choice_label:     'Signing method',
      state_sent:            'Sent on {at} to {email} - awaiting acceptance.',
      state_opened:          'Opened {count}× - last on {at}.',
      state_accepted:        'Accepted on {at}.',
      state_revoked:         'Revoked on {at}.',
      expires_at:            'Expires on {at}.',
      no_guidelines:         'No guidelines available - upload one first under Guidelines.',
      confirm_revoke:        'Revoke the signing link? A fresh session can be started afterward.',
      certificate:           'Download certificate',
      err_pick_guideline:    'Pick a guideline first.',
      err_send:              'Send failed.',
      err_resend:            'Resend failed.',
      err_revoke:            'Revoke failed.',
      err_certificate:       'Certificate download failed.',
    },
    approvals: {
      kind_operator:      'Charge-point operator',
      kind_municipality:  'Municipality',
      label_email:        'Email',
      label_contact_name: 'Contact name (optional)',
      send:               'Send',
      resend:             'Resend',
      force_approve:      'Force approved',
      force_reject:       'Force rejected',
      force_note_label:   'Note (required)',
      force_confirm:      'Force this status? The action is recorded in the audit timeline.',
      state_pending:      'Pending - expires {at}.',
      state_approved:     'Approved on {at}.',
      state_rejected:     'Rejected on {at}.',
      with_note:          'Note: {note}',
      err_email:          'Provide a valid email address.',
      err_send:           'Send failed.',
      err_resend:         'Resend failed.',
      err_force:          'Force failed.',
    },
    account: {
      intro:           'Create an app account for the requester before installation can proceed.',
      created_label:   'Account created',
      confirm:         'Confirm',
      skip:            'Skip',
      confirm_skip:    'Skip the account-creation step? The request will advance to "Ready for install" without an account having been created.',
      state_created:   'Account created on {at} by {by}.',
      state_skipped:   'Step skipped on {at} by {by}.',
      not_yet:         'Available once signing completes.',
      err_unchecked:   'Tick "Account created" first, or click Skip.',
      err_save:        'Save failed.',
    },
    install_party: {
      installer_label:       'Installation party',
      installer_placeholder: '- Pick a party -',
      mode_label:            'Mode',
      mode_notify_only:      'Notify only',
      mode_key_delivery:     'Key delivery',
      template_label:        'Email template',
      template_default:      '- Default (based on organisation) -',
      template_scope_global: 'global',
      send:                  'Send instruction',
      resend:                'Resend',
      state_sent:            '{name} ({mode}) - sent on {at}.',
      not_yet:               'Not briefed yet. Available once the request is "Ready for install".',
      no_parties:            'No installation parties for this organisation - add one first under Installation parties.',
      err_pick:              'Pick an installation party first.',
      err_send:              'Send failed.',
      err_resend:            'Resend failed.',
    },
    final_go: {
      send:        'Send final go email',
      state_sent:  'Sent on {at}.',
      not_yet:     'Send the install-party instruction first.',
      err_send:    'Send failed.',
    },
    audit: {
      kind_note:           'Note',
      kind_audit:          'Admin action',
      kind_signing_event:  'Signer event',
      actor_signer:        'connector',
      empty:               'No activity yet.',
      err_load:            'Failed to load the audit timeline.',
    },
    scan_projects: {
      title:        'Energy-scan projects',
      sub:          'Per-construction-site scouting workspaces - find candidate connection points, public chargers and municipal supply lines around a project. Replaces the standalone Energiescan tool.',
      new_btn:      'New project',
      search_ph:    'Search by number, name, client or project lead…',
      empty:        'No scan projects yet. Click "New project" to create one.',
      col: {
        number:        'No.',
        name:          'Project name',
        client:        'Client',
        project_lead:  'Project lead',
        status:        'Status',
        updated:       'Last updated',
      },
      status: {
        concept:     'Concept',
        in_progress: 'In progress',
        afgerond:    'Completed',
      },
      status_all:   'All statuses',
      map_aria:     'Overview map of all scan projects',
      map_count:    '{n} projects on the map',
      err_load:     'Failed to load projects.',
      err_delete:   'Delete failed.',
      delete_confirm: 'Delete project "{label}"?',
    },
    scan_project: {
      title_new:           'New scan project',
      title_edit:          'Edit scan project',
      back_to_list:        '← Back to overview',
      section_project:     'Project',
      section_client:      'Client',
      section_location:    'Location',
      section_description: 'Description',
      label_number:        'Project number',
      label_name:          'Project name',
      label_client_name:   'Client name',
      label_client_type:   'Client type',
      label_client_org:    'Linked organisation (optional)',
      label_project_lead:  'NRG project lead',
      label_contact:       'Contact person',
      label_planned_start: 'Planned start',
      label_delivery_date: 'Delivery date',
      label_address:       'Address / work site',
      label_latitude:      'Latitude',
      label_longitude:     'Longitude',
      label_short:         'Short description',
      label_workarea:      'Work-area intro',
      label_workdesc:      'Work description',
      label_status:        'Status',
      number_hint:         'Auto-generated in JJNNN format. Click to override.',
      client_org_ph:       '- Not linked -',
      client_type_ph:      'e.g. Municipality, Province, Contractor',
      save_btn:            'Save',
      saved:               'Saved.',
      err_load:            'Failed to load project.',
      err_save:            'Save failed.',
      err_required_name:   'Project name is required.',
      geocode_btn:         'Locate on map',
      map_aria:            'Project area map',
      panel_picker:        'Set location',
      panel_search:        'Search businesses',
      panel_saved:         'Added to project',
      picker_btn:          'Pick on map',
      picker_btn_active:   'Click on the map…',
      picker_hint:         'Click on the map to set the project location. The address is auto-filled when a Google API key is configured.',
      radius_label:        'Radius',
      keyword_label:       'Keyword (optional)',
      keyword_ph:          'e.g. restaurant, café',
      search_btn:          'Search',
      search_btn_busy:     'Searching…',
      search_hint_save_first: 'Save the project first to enable nearby search.',
      search_hint_no_anchor:  'Set the project location first ("Pick on map" or type lat/lng).',
      search_status_hits:  '{count} matches within {radius} m.',
      search_status_zero:  'No matches within {radius} m.',
      saved_empty:         'Nothing added yet.',
      err_search:          'Search failed.',
      err_search_no_key:   'Google Places API is not configured on the server.',
      err_geocode:         'Address not found.',
      err_reverse:         'No address near that point.',
      err_add_station:     'Failed to add.',
      add_to_project_btn:  'Add to project',
      already_added:       'Already added',
      saved_pill_draft:    'draft',
      saved_pill_public:   'public',
      saved_pill_admin:    'admin-only',
      promote_btn:           'Publish',
      promote_confirm_title: 'Confirm publish',
      promote_confirm:       '"{label}" will become visible on the public map. Continue?',
      promote_confirm_btn:   'Publish',
      err_promote:           'Publish failed.',
      open_other_project_btn:'Open project',
      basemap_light:          'Map',
      basemap_satellite:      'Satellite',
      overlay_saved:          'Added to this project',
      overlay_scouts:         'Search results',
      overlay_power:          'Power stations',
      overlay_charging:       'Chargers',
      overlay_other_projects: 'Other scan projects',
      label_powerstation:     'Power station',
      label_charging_ac:      'Charger (AC)',
      label_charging_dc:      'Charger (DC)',
      unassign_btn:           'Remove from project',
      unassign_confirm_title: 'Confirm remove from project',
      unassign_confirm:       '"{label}" will be unlinked from this scan project. The indirect station itself stays in the catalogue - you can re-link it later or manage it from Indirect stations. Continue?',
      unassign_confirm_btn:   'Remove from project',
      err_unassign:           'Remove from project failed.',
    },
  },
};
